import React from 'react';
import './BrandMaterial.sass';

import { constructDevSrc } from '../../utils/helpers';

import { ReactComponent as Logo } from '../../assets/img/branding/color-logo.svg';

{
	/* You can find other 2 logos in the same folder */
}
{
	/* Need to add .uikit-brand-material__image--dark for the item with white logo */
}

interface Props {
	brand: {
		darkMode: boolean;
		logoPreview: {
			_url: string;
			_name: string;
		};
		sVGResource: {
			_url: string;
		};
		pNGResource: {
			_url: string;
		};
		ePSResource: {
			_url: string;
		};
	};
}

function BrandMaterial(props: Props) {
	const { brand } = props;
	return (
		<div className="uikit-brand-material">
			<div
				className={`uikit-brand-material__image${
					brand.darkMode ? ' uikit-brand-material__image--dark' : ''
				}`}
			>
				<img
					src={constructDevSrc(brand.logoPreview._url)}
					alt={brand.logoPreview._name}
				/>
			</div>
			<div className="uikit-text-small uikit-brand-material__links">
				<span>Download:</span>
				{brand.pNGResource && (
					<a
						href={constructDevSrc(brand.pNGResource._url)}
						download
						target="_blank"
						rel="noreferrer"
					>
						PNG
					</a>
				)}
				{brand.ePSResource && (
					<a
						href={constructDevSrc(brand.ePSResource._url)}
						download
						target="_blank"
						rel="noreferrer"
					>
						EPS
					</a>
				)}
				{brand.sVGResource && (
					<a
						href={constructDevSrc(brand.sVGResource._url)}
						download
						target="_blank"
						rel="noreferrer"
					>
						SVG
					</a>
				)}
			</div>
		</div>
	);
}

export default BrandMaterial;
